import authService from "src/helpers/authService"
import { User } from "src/store/User"

export const RouteName = "event-labels"

export function authZ_hasSomeRoutePermission() : boolean {
  return authService(User.userData?.roles ?? [], "registrar", "eventAdmin")
}
